import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { BookingProvider } from "@/context/BookingContext";
import { SettingsProvider } from "@/context/SettingsContext";
import BookingDialog from "@/components/BookingDialog";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import PartyPackages from "@/pages/PartyPackages";
import Events from "@/pages/Events";
import SummerCamps from "@/pages/SummerCamps";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SettingsProvider>
          <BookingProvider>
            <Routes>
              <Route path="/admin" element={<Admin />} />
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/about" element={<Layout><About /></Layout>} />
              <Route path="/packages" element={<Layout><PartyPackages /></Layout>} />
              <Route path="/events" element={<Layout><Events /></Layout>} />
              <Route path="/summer-camps" element={<Layout><SummerCamps /></Layout>} />
            </Routes>
            <BookingDialog />
            <Toaster position="top-center" theme="dark" richColors />
          </BookingProvider>
        </SettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
